enum TT_PHIEU_VTYT {
  NHAP = "NH",
  CHO_DUYET = "CD",
  HOAN_THANH = "HT",
  CANH_BAO = "CB",
  TU_CHOI = "TC",
  HUY = "HP",
}
enum TT_NGUON_VTYT {
  BT = "BT",
  GHH = "GHH",
  HH = "HH",
  // H = "H",
}
enum LOAI_PHIEU_VTYT {
  NHAP = "NH",
  XUAT = "XU",
  DU_TRU = "DT",

  KIEM_KE = "KK",
}
enum NGUON_VTYT {
  TCT = "VTYT tự chi trả",
  BH = "VTYT bảo hiểm",
  TH = "VTYT tổng hợp",
  KH = "Khác",
}
export {TT_PHIEU_VTYT, LOAI_PHIEU_VTYT, NGUON_VTYT, TT_NGUON_VTYT};
